import { useState, useCallback } from 'react';
import { telemetry } from '../../../telemetry';

const SIDEBAR_COLLAPSE_KEY = 'ai-agent-sidebar-collapsed';

export const useSidebarCollapse = () => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      const stored = localStorage.getItem(SIDEBAR_COLLAPSE_KEY);
      return stored ? JSON.parse(stored) : false;
    } catch (e) {
      telemetry.captureError(e);
      return false;
    }
  });

  const toggleCollapse = useCallback(() => {
    setIsCollapsed((prev: boolean) => {
      const newValue = !prev;
      try {
        localStorage.setItem(SIDEBAR_COLLAPSE_KEY, JSON.stringify(newValue));
      } catch (e) {
        telemetry.captureError(e);
      }
      return newValue;
    });
  }, []);

  const setCollapse = useCallback((collapsed: boolean) => {
    setIsCollapsed(collapsed);
    try {
      localStorage.setItem(SIDEBAR_COLLAPSE_KEY, JSON.stringify(collapsed));
    } catch (e) {
      telemetry.captureError(e);
    }
  }, []);

  return {
    isCollapsed,
    toggleCollapse,
    setCollapse,
  };
};
